'use strict';

(function () {
    'use strict';

    angular.module('customers.selectionCustomers', ['ui.router', 'common']);
})();